// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_KO6","col":"styles_col__3Vzrj","actions":"styles_actions__1rIRe","conflict":"styles_conflict__28ieK"};